import React from "react";
import { AbsoluteFill } from "../AbsoluteFill";
import { interpolate } from "../interpolate";
import { spring } from "../Spring";
import { useCurrentFrame } from "../use-current-frame";
import { useVideoConfig } from "../use-video-config";
export const Move = ({ children, delay }) => {
  const { fps } = useVideoConfig();
  const frame = useCurrentFrame();
 
  const down = spring({
    fps,
    frame: frame - delay,
    config: {
      damping: 200,
    },
    durationInFrames: 120,
  });
 
  const y = interpolate(down, [0, 1], [0, -400]);
 
  return (
    <AbsoluteFill
      style={{
        translate: `0 ${y}px`,
      }}
    >
      {children}
    </AbsoluteFill>
  );
};